import api, { getData } from '@/axiosConfig'
import { status } from '../../helpers'
import i18n from '../../internatinalization/i18n'
import router from '@/router'

const gemnoteAPI = api()

import {
  LOAD_PROJECTS_LIST,
  SET_PROJECTS_LIST,
  LOAD_PROJECT_DETAILS,
  LOAD_PUBLIC_PROJECT_DETAILS,
  SET_PROJECT_DETAILS,
  SET_PUBLIC_PROJECT_DETAILS,
  SET_PUBLIC_PROJECT_RECIPIENTS,
  SET_PUBLIC_RECIPIENTS_PAGINATION_COUNT,
  LOAD_PROJECT_LINK_INFO,
  SET_PROJECT_INFO,
  SET_RECIPIENT_CUSTOM_SIZES,
  SETTING_PROJECT_RECIPIENT_INFO,
  // PROJECT_EMAIL_ALREADY_IN_USE,
  UPDATING_ALLOWED_DOMAIN,
  UPDATING_RECIPIENT,
  UPDATING_PUBLIC_RECIPIENT,
  DELETING_RECIPIENT,
  FINALIZING_ORDER,
  FINALIZING_PUBLIC_ORDER,
  SEARCHING_RECIPIENT,
  SET_RECIPIENT_INFO,
  UPDATE_RECIPIENT_INFO,
  SET_RECIPIENT_VERIFICATION_STATUS,
  ENABLE_ADDRESS_COLLECTION,
  DISABLE_ADDRESS_COLLECTION,
  SET_COLLECTION_LINK_STATE,
  VERIFICATION_EMAIL_STATUS,
  VALIDATING_GROUP_ORDER_RECIPIENT
} from '@/state/mutationTypes'

export default {
  // PUBLIC PROJECTS
  async getPublicProjectDetail({ commit, dispatch }, projectToken) {
    try {
      commit(LOAD_PROJECT_DETAILS, status.LOADING)
      let response = await gemnoteAPI.get(`projects/${projectToken}`)
      let data = getData(response)

      let publicProjectDetails = {
        id: parseInt(data.id),
        jwt: projectToken,
        ...data.attributes,
        customerSuccessManagerId: data.attributes.customerSuccessManager
          ? data.attributes.customerSuccessManager.id
          : null,
        customerSuccessManager: data.attributes.customerSuccessManager
          ? `${data.attributes.customerSuccessManager.first_name.trim()} ${
              data.attributes.customerSuccessManager.last_name
                ? data.attributes.customerSuccessManager.last_name.trim()
                : ''
            } `
          : '',
        projectRecipients: response.data.included
          ? response.data.included.map(recipient => {
              return {
                id: parseInt(recipient.id),
                ...recipient.attributes
              }
            })
          : []
      }
      commit(SET_PUBLIC_PROJECT_DETAILS, publicProjectDetails)
      commit(LOAD_PUBLIC_PROJECT_DETAILS, status.LOADED)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.project-details-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getPublicProjectRecipients(
    { commit, dispatch },
    { page, perPage, jwt }
  ) {
    try {
      commit(SEARCHING_RECIPIENT, status.LOADING)
      let response = await gemnoteAPI.get(
        `projects/${jwt}/recipients?page[number]=${page}&page[size]=${perPage}`
      )
      // eslint-disable-next-line no-unused-vars
      let data = getData(response)

      let { totalCount } = response.data.meta

      let projectRecipients = response.data.data.map(recipient => {
        return {
          id: parseInt(recipient.id),
          ...recipient.attributes
        }
      })

      commit(SET_PUBLIC_PROJECT_RECIPIENTS, projectRecipients)
      commit(SET_PUBLIC_RECIPIENTS_PAGINATION_COUNT, totalCount)
      commit(SEARCHING_RECIPIENT, status.LOADED)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.project-details-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async exportPublicRecipient({ state, dispatch }, payload) {
    const publicProjectDetails = state.publicProjectDetails
    try {
      const { data } = await gemnoteAPI.get(
        `projects/${state.publicProjectDetails.jwt}/export_recipient_csv`
      )
      payload(data)
      console.log(data)
      state.publicProjectDetails = publicProjectDetails
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.delete-recipient-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async updatePublicRecipient({ state, dispatch, commit }, payload) {
    // const projectRecipients = state.publicRecipients

    const formData = {
      recipient: {
        name: payload.name,
        email: payload.email,
        address_one: payload.addressOne,
        address_two: payload.addressTwo,
        state: payload.state,
        country: payload.country,
        zip_code: payload.zipCode,
        phone: payload.phone,
        apparel_size: payload.apparelSize,
        city: payload.city
      }
    }
    try {
      commit(UPDATING_PUBLIC_RECIPIENT, true)
      await gemnoteAPI.patch(
        `projects/${state.publicProjectDetails.jwt}/recipients/${payload.id}`,
        formData
      )

      dispatch('getPublicProjectRecipients', {
        page: 1,
        perPage: 50,
        jwt: state.publicProjectDetails.jwt
      })

      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.recipient-updated')]
        },
        { root: true }
      )

      // projectRecipients = projectRecipients.filter(
      //   ({ id }) => !payload.includes(id)
      // )

      // state.projectRecipients = projectRecipients
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.error-updating-recipient'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(UPDATING_RECIPIENT, false)
    }
  },

  async finalizePublicOrder({ state, dispatch, commit }) {
    const publicProjectDetails = state.publicProjectDetails
    try {
      commit(FINALIZING_PUBLIC_ORDER, true)
      const { data } = await gemnoteAPI.patch(
        `projects/${state.publicProjectDetails.jwt}/finalize_submissions`
      )
      publicProjectDetails.state = data.data.attributes.state
      state.publicProjectDetails = publicProjectDetails
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.finalize-order')]
        },
        { root: true }
      )
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.finalize-order-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(FINALIZING_PUBLIC_ORDER, false)
    }
  },

  async deletePublicRecipient({ state, dispatch, commit }, payload) {
    const publicRecipients = state.publicRecipients
    try {
      commit(DELETING_RECIPIENT, true)
      await gemnoteAPI.delete(
        `projects/${state.publicProjectDetails.jwt}/recipients/${payload[0]}`
      )
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.recipient-deleted')]
        },
        { root: true }
      )

      state.publicRecipients = publicRecipients.filter(
        ({ id }) => !payload.includes(id)
      )
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.delete-recipient-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(DELETING_RECIPIENT, false)
    }
  },
  async deletePublicRecipients({ state, dispatch, commit }, payload) {
    const formData = {
      recipient: {
        ids: payload
      }
    }
    try {
      commit(DELETING_RECIPIENT, true)
      await gemnoteAPI.post(
        `projects/${state.publicProjectDetails.jwt}/recipients/bulk_delete`,
        formData
      )
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.recipient-deleted')]
        },
        { root: true }
      )

      state.publicRecipients = state.publicRecipients.filter(
        ({ id }) => !payload.includes(id)
      )
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.delete-recipient-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(DELETING_RECIPIENT, false)
    }
  },

  async getProjectsList({ commit, dispatch }) {
    try {
      commit(LOAD_PROJECTS_LIST, status.LOADING)
      const response = await gemnoteAPI.get('team/admin_orders')
      const data = getData(response)

      let projectsList = data.map(project => {
        return {
          id: project.id,
          name: project.attributes.name,
          inHandsDate: project.attributes.inHandsDate,
          state: project.attributes.state,
          submissions: project.attributes.numberOfSubmissions,
          uuid: project.attributes.uuid,
          manager: project.attributes.customerSuccessManager
            ? `${project.attributes.customerSuccessManager.first_name} ${project.attributes.customerSuccessManager.last_name} `
            : ''
        }
      })

      commit(SET_PROJECTS_LIST, projectsList)
      commit(LOAD_PROJECTS_LIST, status.LOADED)
    } catch (error) {
      commit(LOAD_PROJECTS_LIST, status.LOADED)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.get-project-list-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getProjectDetail({ commit, dispatch }, projectId) {
    try {
      commit(LOAD_PROJECT_DETAILS, status.LOADING)
      let response = await gemnoteAPI.get(`team/admin_orders/${projectId}`)

      let projectDetails = formatProjectDetails(response)

      commit(SET_PROJECT_DETAILS, projectDetails)
      commit(LOAD_PROJECT_DETAILS, status.LOADED)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.project-details-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async enableAddressCollectionLink({ commit, dispatch }, projectId) {
    try {
      commit(ENABLE_ADDRESS_COLLECTION, status.LOADING)
      let response = await gemnoteAPI.post(
        `team/admin_orders/${projectId}/enable_address_collection_link`
      )
      let data = getData(response)

      let enableCollectionLink = data.attributes.enableCollectionLink

      commit(SET_COLLECTION_LINK_STATE, true)

      commit(ENABLE_ADDRESS_COLLECTION, status.LOADED)

      // dispatch(
      //   'notification/pushNotification',
      //   {
      //     type: 'success',
      //     messages: [i18n.t('projects.action.enable-address-collection-link-success')]
      //   },
      //   { root: true }
      // )
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.project-details-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async enableEmailVerification({ commit, dispatch }, uuid) {
    try {
      let response = await gemnoteAPI.post(
        `team/admin_orders/${uuid}/enable_email_verification`
      )

      let data = getData(response)
      let projectDetails = {
        id: parseInt(data.id),
        ...data.attributes,
        customerSuccessManager: data.attributes.customerSuccessManager
          ? `${data.attributes.customerSuccessManager.first_name.trim()} ${data.attributes.customerSuccessManager.last_name.trim()} `
          : '',
        projectRecipients:
          response.data && response.data.included
            ? response.data.included.map(recipient => {
                return {
                  id: parseInt(recipient.id),
                  ...recipient.attributes
                }
              })
            : []
      }
      commit(SET_PROJECT_DETAILS, projectDetails)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.gorder-startautofinalize-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async disableEmailVerification({ commit, dispatch }, uuid) {
    try {
      let response = await gemnoteAPI.post(
        `team/admin_orders/${uuid}/disable_email_verification`
      )

      let data = getData(response)
      let projectDetails = {
        id: parseInt(data.id),
        ...data.attributes,
        customerSuccessManager: data.attributes.customerSuccessManager
          ? `${data.attributes.customerSuccessManager.first_name.trim()} ${data.attributes.customerSuccessManager.last_name.trim()} `
          : '',
        projectRecipients:
          response.data && response.data.included
            ? response.data.included.map(recipient => {
                return {
                  id: parseInt(recipient.id),
                  ...recipient.attributes
                }
              })
            : []
      }
      commit(SET_PROJECT_DETAILS, projectDetails)
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [...errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              i18n.t('grouporder.action.gorder-startautofinalize-error')
            ]
          },
          { root: true }
        )
      }
    }
  },
  async disableAddressCollectionLink({ commit, dispatch }, projectId) {
    try {
      commit(DISABLE_ADDRESS_COLLECTION, status.LOADING)
      let response = await gemnoteAPI.post(
        `team/admin_orders/${projectId}/disable_address_collection_link`
      )
      let data = getData(response)

      let enableCollectionLink = data.attributes.enableCollectionLink

      commit(SET_COLLECTION_LINK_STATE, false)

      // dispatch(
      //   'notification/pushNotification',
      //   {
      //     type: 'success',
      //     messages: [i18n.t('projects.action.enable-address-collection-link-success')]
      //   },
      //   { root: true }
      // )

      commit(DISABLE_ADDRESS_COLLECTION, status.LOADED)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.enable-address-collection-link-success'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async getProjectRecipients({ commit, dispatch }, projectId) {
    try {
      commit(SEARCHING_RECIPIENT, status.LOADING)
      let response = await gemnoteAPI.get(`team/admin_orders/${projectId}`)
      let data = getData(response)

      let projectDetails = {
        id: parseInt(data.id),
        ...data.attributes,
        customerSuccessManager: data.attributes.customerSuccessManager
          ? `${data.attributes.customerSuccessManager.first_name.trim()} ${data.attributes.customerSuccessManager.last_name.trim()} `
          : '',
        projectRecipients:
          response.data && response.data.included
            ? response.data.included.map(recipient => {
                return {
                  id: parseInt(recipient.id),
                  ...recipient.attributes
                }
              })
            : []
      }
      commit(SET_PROJECT_DETAILS, projectDetails)
      commit(SEARCHING_RECIPIENT, status.LOADED)
    } catch (error) {
      console.log(error)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.project-details-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async sendRecipientVerificationEmail(
    { commit, dispatch, state },
    { email, password, uuid, resend }
  ) {
    try {
      if (email.trim() === '') {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('validations.blank-email')]
          },
          { root: true }
        )
        return
      }

      const response = await gemnoteAPI.post(
        `team/admin_orders/${uuid}/order_recipients/send_verification_email`,
        {
          email,
          password
        }
      )

      const data = response.data

      if (data.verified) {
        commit(UPDATE_RECIPIENT_INFO, { email })
        commit(SET_RECIPIENT_VERIFICATION_STATUS, data.verified)

        if (state.recipientInfo.email) {
          if (!state.projectInfo.products.length) {
            return router.push(`/admin-order-recipients/${uuid}/recipient`)
          } else {
            return router.push(
              `/admin-order-recipients/${uuid}/items-selection`
            )
          }
        } else {
          if (!state.projectInfo.products.length) {
            return router.push(`/admin-order-recipients/${uuid}/recipient`)
          } else {
            return router.push(
              `/admin-order-recipients/${uuid}/items-selection`
            )
          }
        }
      }

      if (resend) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'success',
            messages: ['Verification email resent successfully!']
          },
          { root: true }
        )
      }

      commit(VERIFICATION_EMAIL_STATUS, data.verification_email_sent)
    } catch (error) {
      console.log(error)
      commit(VALIDATING_GROUP_ORDER_RECIPIENT, false)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          const data = error.response && error.response.data
          let { errors, message } = data

          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors ? [errors[0].message] : [message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-login-recipient-error')]
          },
          { root: true }
        )
      }
    }
  },

  async verifyAdminOrderRecipient({ commit, dispatch }, { uuid, token }) {
    try {
      const response = await gemnoteAPI.post(
        `team/admin_orders/${uuid}/order_recipients/verify`,
        {
          token
        }
      )

      const { email, verified } = response.data
      commit(UPDATE_RECIPIENT_INFO, { email })
      commit(SET_RECIPIENT_VERIFICATION_STATUS, verified)
      if (verified) {
        router.push({
          name: 'EmailVerificationSuccess',
          params: {
            redirect: 'ProjectItemsSelection',
            uuid
          }
        })
      } else {
        router.push({ name: 'ProjectRecipientLogin' })
      }
    } catch (error) {
      console.log(error)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('grouporder.action.gorder-login-recipient-error')]
          },
          { root: true }
        )
      }
    }
  },

  async updateOktaRecipient({ commit }, { email, uuid }) {
    commit(UPDATE_RECIPIENT_INFO, { email })
    commit(SET_RECIPIENT_VERIFICATION_STATUS, true)

    await router.push({
      name: 'EmailVerificationSuccess',
      params: {
        redirect: 'ProjectItemsSelection',
        uuid
      }
    })
  },

  async getProjectLinkInfo({ commit, dispatch, state }, { projectId }) {
    if (state.projectInfo.id) return
    try {
      commit(LOAD_PROJECT_LINK_INFO, status.LOADING)
      let response = await gemnoteAPI.get(
        `team/admin_orders/${projectId}/details`
      )

      let data = getData(response)
      const { included } = response.data || {}
      let projectInfo = {
        id: data.id,
        ...data.attributes,
        products: included
          ? included.map(product => {
              return {
                id: product.id,
                ...product.attributes
              }
            })
          : []
      }

      if (data.attributes.orderFinalized) {
        return await router.push('/404').catch(err => {})
      } else {
        await commit(SET_PROJECT_INFO, projectInfo)
      }

      if (state.recipientInfo.email) {
        if (!projectInfo.products.length) {
          return router.push(`/admin-order-recipients/${projectId}/recipient`)
        } else {
          return router.push(
            `/admin-order-recipients/${projectId}/items-selection`
          )
        }
      }

      commit(LOAD_PROJECT_LINK_INFO, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_PROJECT_LINK_INFO, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.get-project-link-info-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  setCustomApparelSizes({ commit }, { name, option, index }) {
    commit(SET_RECIPIENT_CUSTOM_SIZES, { name, option, index })
  },
  async confirmRecipientInfo({ commit, dispatch, state }, projectId) {
    try {
      commit(SETTING_PROJECT_RECIPIENT_INFO, true)
      let { recipientInfo } = state
      const selections =
        JSON.parse(localStorage.getItem('adminOrderSelectedItems')) || []

      let transformedSelections = selections.map(product => {
        return {
          name: product.name,
          option: product.option
        }
      })

      const body = {
        recipient: {
          name: recipientInfo.name,
          email: recipientInfo.email,
          phone: recipientInfo.phone,
          address_one: recipientInfo.addressOne,
          address_two: recipientInfo.addressTwo,
          city: recipientInfo.city,
          state: recipientInfo.state,
          zip_code: recipientInfo.zipcode,
          country: recipientInfo.country,
          apparel_size: transformedSelections
        }
      }

      const response = await gemnoteAPI.post(
        `team/admin_orders/${projectId}/order_recipients`,
        body
      )

      if (response.status === 200) {
        commit(SETTING_PROJECT_RECIPIENT_INFO, false)
        router.push({
          name: 'AddressCollectionConfirm',
          props: { uuid: projectId }
        })

        localStorage.removeItem('adminOrderSelectedItems')
        localStorage.removeItem('projectRecipientInfo')
        commit(SET_RECIPIENT_INFO)
      }
    } catch (error) {
      console.log(error)
      commit(SETTING_PROJECT_RECIPIENT_INFO, false)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.resquest) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.set-recipient-info-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async updateWhitelistedDomain(
    { state, rootState, dispatch, commit },
    domains
  ) {
    const formData = {
      admin_order: {
        expected_number_of_recipients:
          state.projectDetails.expectedNumberOfRecipients,
        allowed_domains: domains,
        admin_order_title: state.projectDetails.adminOrderTitle,
        admin_order_description: state.projectDetails.adminOrderDescription,
        apparel_size_options: [],
        customer_success_manager_id:
          state.projectDetails.customerSuccessManagerId,
        paige_team_id: rootState.team.team.id
      }
    }
    try {
      commit(UPDATING_ALLOWED_DOMAIN, true)
      await gemnoteAPI.patch(
        `team/admin_orders/${state.projectDetails.id}`,
        formData
      )
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.allowed-domain-updated')]
        },
        { root: true }
      )
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else if (error.resquest) {
          errors.push(i18n.t('server.no-response'))
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        } else {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      }
    } finally {
      commit(UPDATING_ALLOWED_DOMAIN, false)
    }
  },
  async updateAdminorderAttatchments({ state, dispatch, commit }, formData) {
    // const formData = {
    //   admin_order: {
    //     expected_number_of_recipients:
    //       state.projectDetails.expectedNumberOfRecipients,
    //     allowed_domains: state.projectDetails.allowedDomains,
    //     admin_order_title: state.projectDetails.adminOrderTitle,
    //     admin_order_description: state.projectDetails.adminOrderDescription,
    //     apparel_size_options: [],
    //     customer_success_manager_id:
    //       state.projectDetails.customerSuccessManagerId,
    //     paige_team_id: rootState.team.team.id,
    //     admin_order_attatchments: attatchments
    //   }
    // }
    try {
      commit(FINALIZING_ORDER, true)
      await gemnoteAPI.patch(
        `team/admin_orders/${state.projectDetails.uuid}`,
        formData
      )
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.allowed-domain-updated')]
        },
        { root: true }
      )
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push("Error updating project's order")
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(FINALIZING_ORDER, false)
    }
  },

  async updateRecipient({ state, dispatch, commit }, payload) {
    const formData = {
      recipient: {
        name: payload.name,
        email: payload.email,
        address_one: payload.addressOne,
        state: payload.state,
        zip_code: payload.zipCode,
        phone: payload.phone,
        apparel_size: payload.apparelSize,
        city: payload.city,
        country: payload.country
      }
    }
    try {
      commit(UPDATING_RECIPIENT, true)
      await gemnoteAPI.put(
        `team/admin_orders/${state.projectDetails.uuid}/order_recipients/${payload.id}`,
        formData
      )
      dispatch('getProjectRecipients', state.projectDetails.id)
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.recipient-updated')]
        },
        { root: true }
      )
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.error-updating-recipient'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(UPDATING_RECIPIENT, false)
    }
  },
  async deleteRecipients({ state, dispatch, commit }, payload) {
    const projectDetails = state.projectDetails
    const formData = {
      recipient: {
        ids: payload
      }
    }

    try {
      commit(DELETING_RECIPIENT, true)
      await gemnoteAPI.post(
        `team/admin_orders/${state.projectDetails.uuid}/order_recipients/bulk_delete`,
        formData
      )
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.recipient-deleted')]
        },
        { root: true }
      )

      projectDetails.projectRecipients = projectDetails.projectRecipients.filter(
        ({ id }) => !payload.includes(id)
      )

      state.projectDetails = projectDetails
      // dispatch('getProjectDetail', id)
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.delete-recipient-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(DELETING_RECIPIENT, false)
    }
  },

  async exportRecipient({ state, dispatch }, payload) {
    const projectDetails = state.projectDetails
    try {
      const { data } = await gemnoteAPI.get(
        `team/admin_orders/${state.projectDetails.uuid}/export_recipient_csv`
      )
      payload(data)
      state.projectDetails = projectDetails
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.delete-recipient-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },

  async finalizeOrder({ state, dispatch, commit }) {
    const projectDetails = state.projectDetails
    try {
      commit(FINALIZING_ORDER, true)
      const { data } = await gemnoteAPI.patch(
        `team/admin_orders/${state.projectDetails.uuid}/finalize_submissions`
      )
      projectDetails.state = data.data.attributes.state
      state.projectDetails = projectDetails
      dispatch(
        'notification/pushNotification',
        {
          type: 'success',
          messages: [i18n.t('projects.action.finalize-order')]
        },
        { root: true }
      )
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('projects.action.finalize-order-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(FINALIZING_ORDER, false)
    }
  },

  async updateProjectOrder({ state, dispatch, commit }, payload) {
    const oldProjectDetails = state.projectDetails
    try {
      commit(FINALIZING_ORDER, true)
      const response = await gemnoteAPI.patch(
        `team/admin_orders/${state.projectDetails.uuid}`,
        payload
      )

      const projectDetails = {
        ...oldProjectDetails,
        ...formatProjectDetails(response)
      }
      projectDetails.projectRecipients = oldProjectDetails.projectRecipients
      commit(SET_PROJECT_DETAILS, projectDetails)
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [errors[0].message[0]]
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push("Error updating project's order")
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    } finally {
      commit(FINALIZING_ORDER, false)
    }
  }
}

function formatProjectDetails({ data: { data, included } }) {
  return {
    id: parseInt(data.id),
    ...data.attributes,
    customerSuccessManagerId: data.attributes.customerSuccessManager
      ? data.attributes.customerSuccessManager.id
      : null,
    customerSuccessManager: data.attributes.customerSuccessManager
      ? `${data.attributes.customerSuccessManager.first_name.trim()} ${data.attributes.customerSuccessManager.last_name.trim()} `
      : '',
    projectRecipients: included
      ? included
          .map(recipient => {
            return {
              id: parseInt(recipient.id),
              type: recipient.type,
              ...recipient.attributes
            }
          })
          .filter(user => user.type === 'recipients')
      : []
  }
}
